import React from 'react';

import { EikaModal } from '../EikaModal';

type Props = {
    id: string;
    className?: string;
    openEditModalState: [boolean, React.Dispatch<boolean>];
    open: boolean;
    onClose: () => void;
    hideCloseButton?: boolean;
    editModalChildren: React.ReactNode;
    isAvtalegiro?: boolean;
    isSuccess?: boolean;
} & React.PropsWithChildren;

const PaymentDetailsModal: React.FC<Props> = ({
    id,
    className,
    openEditModalState,
    open,
    onClose,
    hideCloseButton,
    children,
    editModalChildren,
    isAvtalegiro = false,
    isSuccess = false,
}) => {
    const [openEditModal, setOpenEditModal] = openEditModalState;
    return (
        <EikaModal
            hideCloseButton={hideCloseButton}
            id={id}
            open={open}
            setOpen={() => null}
            onClose={onClose}
            timeOut={isSuccess ? 2500 : undefined}
            className={className}
            size="wide"
            desktopMinHeight="small"
            contentShouldStretch
        >
            {children}
            {!isAvtalegiro && (
                <EikaModal
                    contentShouldStretch
                    open={openEditModal}
                    setOpen={setOpenEditModal}
                    hideCloseButton={hideCloseButton}
                >
                    {editModalChildren}
                </EikaModal>
            )}
        </EikaModal>
    );
};

export default PaymentDetailsModal;
